module.exports = __webpack_public_path__ + "img/globe.c4886b20.svg";